import { PackServiceContext } from "../../../../digital-journey/ServicePage/context/PackServiceContext"
import useGetDeliveryMethodsByOrder from "../../hooks/useGetDeliveryMethodsByOrder"
import useGetSimulationDataFromOPL from "../../hooks/useGetSimulationDataFromOPL"
import useLocalStorageSimulationForm from "../../hooks/useLocalStorageSimulationForm"
import { useContext } from "react"

export default function useSimulationInput(opl) {
  const { resetPackContext, setSelectedPack, getLocalStorageServicePackObject } = useContext(PackServiceContext)
  const { getLocalStorageSimulationForm } = useLocalStorageSimulationForm()

  const { order, isLoadingOrder } = useGetSimulationDataFromOPL(opl)
  const { deliveryMethods, isLoadingDeliveryMethods } = useGetDeliveryMethodsByOrder(order)

  function simulationFormBuilder(order, deliveryMethods) {
    let selectedDeliveryMethod = []
    if (!order) return null

    if (deliveryMethods && deliveryMethods.length !== 0) {
      selectedDeliveryMethod = deliveryMethods?.find((x) => x.code === order?.deliveryMethodParameter) ?? {
        value: deliveryMethods[0]?.id,
        label: deliveryMethods[0]?.label
      }
    }

    return {
      shop: {
        value: order?.supplierId + "-" + order?.supplierReference,
        label: order?.supplierName
      },
      delivery: selectedDeliveryMethod,
      products: order?.products?.map((product) => {
        const skuAndDesignation = product?.skuDistributor + " - " + product?.designation
        return {
          brand: product.brand,
          category: {
            value: product?.categoryEvollis?.id,
            label: product?.categoryEvollis?.label
          },
          description: product?.smallDescription,
          family: {
            value: product?.categoryEvollis?.parentCategoryId,
            label: product?.categoryEvollis?.labelCategoryParent
          },
          price: product?.priceIncTaxes,
          quantity: "1",
          sku: {
            label: skuAndDesignation,
            value: product
          }
        }
      })
    }
  }

  function setInitialValues(initialValue, additionnalValues) {
    if (additionnalValues) {
      return {
        ...initialValue,
        ...additionnalValues
      }
    }
    if (!getLocalStorageServicePackObject) return initialValue

    return {
      ...initialValue,
      ...getLocalStorageSimulationForm
    }
  }

  const valuesFromOrder = simulationFormBuilder(order, deliveryMethods)

  return {
    resetPackContext,
    setSelectedPack,
    getLocalStorageServicePackObject,
    getLocalStorageSimulationForm,
    order,
    isLoadingOrder,
    deliveryMethods,
    isLoadingDeliveryMethods,
    valuesFromOrder,
    setInitialValues
  }
}
